export default __webpack_public_path__ + "static/media/nodal.357d62af.svg";